import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { STATUSES } from "../lib/api";
import { StatusBadge } from "./StatusBadge";

const CELL_BG = {
  done: "bg-emerald-500/15 border-emerald-500/40 text-emerald-300",
  in_progress: "bg-sky-500/15 border-sky-500/40 text-sky-300",
  not_started: "bg-slate-500/10 border-slate-500/30 text-slate-300",
  none: "bg-transparent border-dashed border-[color:var(--border)] text-[color:var(--muted)]",
};

export const AssignmentMatrix = ({ teams, jobs, assignments, onChange, readOnly }) => {
  const find = (t, j) => assignments.find((a) => a.team_id === t && a.job_id === j);
  return (
    <div data-testid="matrix-container" className="panel overflow-x-auto">
      <table className="w-full min-w-[760px] text-sm">
        <thead>
          <tr className="border-b border-[color:var(--border)]">
            <th className="label px-4 py-3 text-left font-normal">Job (Weight)</th>
            {teams.map((t) => (
              <th key={t.id} className="px-3 py-3 text-left">
                <div className="font-display font-semibold">{t.name}</div>
                <div className="text-xs font-normal text-[color:var(--muted)]">{t.members.join(", ")}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {jobs.map((j) => (
            <tr key={j.id} className="border-b border-[color:var(--border)] last:border-0">
              <td className="px-4 py-2.5"><span className="font-mono text-[color:var(--muted)]">{j.no}.</span> {j.name} <span className="font-mono text-xs text-amber-400">w{j.weight}</span></td>
              {teams.map((t) => {
                const a = find(t.id, j.id);
                const v = a?.status || "none";
                return (
                  <td key={t.id} data-testid={`matrix-cell-${t.id}-${j.id}`} className="px-3 py-2">
                    {readOnly ? (v === "none" ? <span className="font-mono text-xs text-[color:var(--muted)]">—</span> : <StatusBadge status={v} testId={`matrix-badge-${t.id}-${j.id}`} />) : (
                    <Select value={v} onValueChange={(nv) => onChange(t.id, j.id, nv === "none" ? null : nv)}>
                      <SelectTrigger data-testid={`matrix-status-selector-${t.id}-${j.id}`} className={`h-8 rounded-sm border font-mono text-xs transition-colors ${CELL_BG[v]}`}>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="none">— Unassigned</SelectItem>
                        {STATUSES.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}
                      </SelectContent>
                    </Select>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
